import React, { useState, useEffect, useCallback, useRef } from "react";
import { Col, Row } from "react-bootstrap";
// import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import ReactLoading from "react-loading";

import TrackingBar from "../component/TrackingBar";
import CardUser from "../component/CardUser";
import CardOrder from "../component/CardOrder";
import SessionUtil from "../util/SessionUtil";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";

import Echo from "laravel-echo";
import Pusher from "pusher-js"; // MUST be here!

// THIS IS CRITICAL!
window.Pusher = Pusher;

function TrackingDriver() {
  const lang = SessionUtil.getLang();
  const { t } = useTranslation();
  const location = useLocation();
  const { state } = location;

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [Orders, setOrders] = useState([]);
  const isLoggedIn = SessionUtil.isLoggedIn();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingMap, setLoadingMap] = useState(true);
  const [statusTrack, setStatusTrack] = useState("");
  const [firstTime, setFirstTime] = useState(false);
  const API_KEY = "AIzaSyDN4yzxt2T7WRuBQ-zmkMIk4wpDLr6ryyY";
  const mapContainerStyle = { width: "100%", height: "600px" };
  const mapRef = useRef(null);

  const getApi = useCallback(async () => {
    try {
      const params = { DriverId: state.id };
      const res = await ApiUtil.postApi(ApiPath.GET_TRACKING_DRIVER_FOR_OPERATION, params, "POST");
      if (res.IsSuccessfull) {
        setData(res.Result.Driver);
        setStatusTrack(res.Result.Driver.Status);
        setFirstTime(!(res.Result.Driver.Status === 'ONLINE' && res.Result.Driver.StoreLocation === null));
        setOrders(res.Result.OrderDetails);
      }
    } catch (error) {
      console.error("Error fetching driver data:", error);
    } finally {
      setLoading(false);
    }
  }, [state.id]);

  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [isLoggedIn, getApi]);

  useEffect(() => {
    // Only use this global, DO NOT set client in Echo config!
    const echo = new Echo({
      broadcaster: 'reverb',
      key: 'local',
      wsHost: process.env.REACT_APP_WS_HOST || "deliveritdev2.deliverit.cc",
      wsPort: 443,
      wsPath: '/ws',
      forceTLS: true,
      disableStats: true,
      enabledTransports: ['wss','ws'],
    });

    const channel = echo.channel(`tracking-driver.${state.id}`);

    channel.listen(".TrackingDriverResponse", (jsonObject) => {
      console.log('jsonObject',jsonObject);
      const [latitude, longitude] = jsonObject.geocoordinate.split(",").map(coord => parseFloat(coord.trim()));
      setLat(latitude);
      setLng(longitude);
      setStatusTrack(jsonObject.statusTrack);
      setFirstTime(jsonObject.statusTrack)
      // setFirstTime(!(jsonObject.Status === "ONLINE" && jsonObject.StoreLocation === null));
      if (jsonObject.Status === "APPROVED") {
        getApi();
      }
      setLoadingMap(false);
    });

    return () => {
      echo.leave(`tracking-driver.${state.id}`);
    };
  }, [state.id, getApi]);

  const onLoad = (mapInstance) => {
    mapRef.current = mapInstance;
  };

  return (
    <Row className="g-0 my-4">
      {!loading ? (
        <>
          <Col lg={8} className="position-relative">
            <div className="flex-gap-2">
              {/* <Nav.Link href={state.page === 'operation' ? "/operation" : "/live-driver-list"}>
                {lang === "en" ? <IoMdArrowRoundBack size={20} /> : <IoMdArrowRoundForward size={20} />}
              </Nav.Link> */}
              <p className="title mb-0">{t("Tracking Driver")}</p>
            </div>

            {!loadingMap ? (
              <div className="map-style position-relative" style={mapContainerStyle}>
                <LoadScript googleMapsApiKey={API_KEY}>
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={{ lat: lat || 0, lng: lng || 0 }}
                    zoom={17}
                    onLoad={onLoad}
                    options={{ disableDefaultUI: true }}
                  >
                    <Marker
                      position={{ lat: lat || 0, lng: lng || 0 }}
                      icon={{ url: "/images/transport.png", scaledSize: { width: 80, height: 80 } }}
                    />
                  </GoogleMap>
                </LoadScript>
                {firstTime && (
                  <div className="position-absolute div-tracking-bar">
                    <TrackingBar data={data} statusTrack={statusTrack} />
                  </div>
                )}
              </div>
            ) : (
              <div className="loading-style flex-column">
                <ReactLoading type="cubes" color="#c8c8c8" height={50} width={50} />
                <p>{t('Please wait to fetch driver coordinates')}</p>
              </div>
            )}
          </Col>

          <Col md={1}>
            <div className="divider-vertical mx-auto"></div>
          </Col>
          <Col lg={3} className="mt-5">
            <CardUser data={data} statusTrack={statusTrack} />
            {Orders.length > 0 && <CardOrder data={Orders} storeData={data} />}
          </Col>
        </>
      ) : (
        <Col lg={12} className="loading-style">
          <ReactLoading type="bars" color="#c8c8c8" height={50} width={50} />
        </Col>
      )}
    </Row>
  );
}

export default TrackingDriver;
